import { Grid2, Typography } from '@mui/material'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import Container from '../../../components/Container'
import api from '../../../utils/axios'
import { ITranslation } from 'sierra'
import TranslationSkeleton from '../../../components/Skeletons/TranslationSkeleton'
import TranslationRow from '../../../components/Cards/TranslationRow'
import socket from '../../../utils/socket'
import { useApp } from '../../../contexts/AppContext'

interface IFilteredTranslations {
    branch_name?: ITranslation[];
    service_name?: ITranslation[];
    service_desc?: ITranslation[];
    step_name?: ITranslation[];
    field_label?: ITranslation[];
    field_desc?: ITranslation[];
    field_placeholder?: ITranslation[];
    field_options?: ITranslation[];
    message?: ITranslation[];
}

const SystemTranslations = memo(() => {
    const { translate } = useApp()

    const [translations, setTranslations] = useState<ITranslation[]>()

    const fetchTranslations = useCallback(() => {
        api.get('/translations').then(res => {
            setTranslations(res.data)
            console.log(res.data);
        }).catch(console.error)
    }, [])

    useEffect(() => {
        fetchTranslations()
    }
        , [])

    const filteredTranslations: IFilteredTranslations = useMemo(() => {
        if (translations && translations.length > 0) {
            return translations.reduce<Record<string, ITranslation[]>>((acc, obj: ITranslation) => {
                const value = obj['translation_type'];
                if (value) {
                    if (!acc[value]) {
                        acc[value] = [];
                    }
                    acc[value].push(obj);
                }
                return acc;
            }, {});
        }
        return {};
    }, [translations]);


    return (
        <Grid2 container size={'grow'} spacing={2}>

            <Grid2 container size={'grow'} flexDirection={'column'} spacing={2}>

                <Container container size={'auto'} padding={2} justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='h4' fontWeight={'bold'} color='primary'>
                            {translate("Translations")}
                        </Typography>
                    </Grid2>
                </Container>

                <Container container overflow={'auto'} spacing={2} padding={2}>
                    {
                        !translations ?
                            Array.from({ length: 1 }).map((a, i) => <TranslationSkeleton key={i} />)
                            : translations.length === 0 ? <Typography>{translate("No translations")}</Typography>
                                :

                                [
                                    { types: ['branch_name'], title: translate('Branches Translations') },
                                    { types: ['service_name', 'service_desc', 'step_name', 'field_label', 'field_desc', 'field_placeholder', 'field_options'], title: translate('Services Translations') },
                                    { types: ['message'], title: translate('Chat Bot Translations') },
                                ].map((obj, i) =>
                                    obj.types.some((o) => filteredTranslations[o as keyof IFilteredTranslations] && filteredTranslations[o as keyof IFilteredTranslations]![0]) ?
                                        <Grid2 container key={i} size={12} flexDirection={'column'} paddingTop={i !== 0 ? 4 : 0} paddingBottom={4} borderTop={i !== 0 ? '1px grey solid' : undefined}>
                                            <Grid2>
                                                <Typography variant="h6" fontWeight={"bold"}>
                                                    {obj.title}
                                                </Typography>
                                            </Grid2>
                                            {obj.types.map((objType, i) =>
                                                <Grid2 container key={i} flexDirection={"column"} spacing={2}>
                                                    <Grid2 container paddingTop={i !== 0 ? 4 : 0}>
                                                        <Grid2 size={"auto"} minWidth={200} display={{ xs: 'none', sm: 'flex' }}>
                                                            <Typography fontWeight={"bold"}>{translate("Type of Translation")}</Typography>
                                                        </Grid2>
                                                        {[translate("English"), translate("Arabic"), translate("Chinese")].map((l, i) => (
                                                            <Grid2 size={"grow"} key={i}>
                                                                <Typography fontWeight={"bold"}>{l}</Typography>
                                                            </Grid2>
                                                        ))}
                                                        {/* <Grid2 minWidth={100}>
                                                        </Grid2> */}
                                                    </Grid2>
                                                    {filteredTranslations[objType as keyof IFilteredTranslations]?.map((t, i) => (
                                                        <TranslationRow key={i} translation={t} />
                                                    ))}
                                                </Grid2>
                                            )}
                                        </Grid2> : <></>
                                )



                    }
                </Container>

            </Grid2>

        </Grid2>
    )
})

export default SystemTranslations
